import { render } from "./RecordingCard.vue?vue&type=template&id=07332d1a"
import script from "./RecordingCard.vue?vue&type=script&lang=js"
export * from "./RecordingCard.vue?vue&type=script&lang=js"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__